import React from 'react';
import { AppointmentStatus, TourItemType } from '@bb/domain/dist/types';
import { format } from 'date-fns';
import styled from 'styled-components';

import { ListingImage, Tag, Text, Tooltip, theme } from '../../components';
import TourShowingStatus from '../../Router/pages/TourEditPage/TourSideNav/TourShowingStatus';
import { TourItemContent } from '../../Router/pages/TourEditPage/types';

type AppointmentItemContainerProps = {
  thumbnail?: string;
  address?: string;
  time?: Date;
  timeEnd?: Date;
  originalTime?: Date;
  originalTimeEnd?: Date;
  status?: AppointmentStatus;
  displayStatus?: string;
  appointmentId?: string;
  listingContactTimeChange?: boolean;
  type: TourItemType;
  isPending?: boolean;
  isUnclaimed?: boolean;
};

const AppointmentItemContainer: React.FC<AppointmentItemContainerProps> = ({
  thumbnail,
  address,
  time,
  timeEnd,
  originalTime,
  originalTimeEnd,
  status,
  displayStatus,
  appointmentId,
  listingContactTimeChange,
  type,
  isPending,
  isUnclaimed,
}) => {
  const suggestedTime = originalTime ? time : undefined;
  const suggestedTimeEnd = originalTimeEnd ? timeEnd : undefined;

  let startTimeToShow;
  let endTimeToShow;
  if (status === 'suggested_time_change' || status === 'time_change') {
    startTimeToShow = originalTime;
    endTimeToShow = originalTimeEnd;
  } else {
    startTimeToShow = time;
    endTimeToShow = timeEnd;
  }

  return (
    <StyledAppointmentItemContainer>
      <StyledPreviewContainer>
        <ListingImage imageSrc={thumbnail} size={36} />
      </StyledPreviewContainer>
      <StyledTitle ellipsis>{address}</StyledTitle>
      {isUnclaimed && (
        <Tooltip
          title={
            'This listing is not represented by BrokerBay. Please ensure to book via the correct showing service.'
          }
        >
          <Tag color="red">Not BrokerBay</Tag>
        </Tooltip>
      )}
      <Text block>
        {!startTimeToShow
          ? 'No times selected'
          : `${format(startTimeToShow, 'h:mmaaa')} - ${format(
              endTimeToShow,
              'h:mmaaa',
            )}`}
      </Text>
      <TourShowingStatus
        item={
          {
            status,
            displayStatus,
            listingContactTimeChange,
            appointmentId,
            time: suggestedTime,
            timeEnd: suggestedTimeEnd,
            type,
            isPending,
          } as unknown as TourItemContent
        }
      />
    </StyledAppointmentItemContainer>
  );
};

export default AppointmentItemContainer;

const StyledTitle = styled(Text)`
  margin-right: 5px;
  && {
    width: 65%;
  }
`;

const StyledPreviewContainer = styled.div`
  float: left;
  margin-right: 16px;
  margin-top: 5px;
  margin-bottom: 30px;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  object-fit: cover;
`;

const StyledAppointmentItemContainer = styled.div`
  width: 100%;
  height: 72px;

  & > ${Text} {
    font-weight: 500;
  }

  & div,
  ${Text} + ${Text} {
    font-weight: normal;
    color: ${theme.gray8};
  }
`;
